import LoginStore from '@/stores/CommonStores/LoginStore/LoginStore'
import RegisterTeamStore from './registerTeam/RegisterTeamStore'
import EnterAccountStore from './registerTeam/EnterAccountStore'
import MessageDialogStore from './dialog/MessageDialogStore'
import PasswordChangeStore from './passwordChange/PasswordChangeStore'
import MailAddressChangeStore from './mailAddressChange/MailAddressChangeStore'
import ErrorStore from './error/ErrorStore'
import MailAddressRegistrationStore from './registerTeam/MailAddressRegistrationStore'

/**
 * このプロジェクトで利用するStoreのMapリスト
 */
const Stores = {
  LoginStore,
  RegisterTeamStore,
  EnterAccountStore,
  MessageDialogStore,
  PasswordChangeStore,
  MailAddressChangeStore,
  ErrorStore,
  MailAddressRegistrationStore,
}
export default Stores

export type StoresType = typeof Stores
